/* eslint-disable object-shorthand */
// authApi.ts

import { baseApi } from './baseApi';

const authApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    // user api
    createUser: build.mutation({
      query: (data) => ({
        url: '/user/registration',
        method: 'POST',
        data: data,
      }),
      invalidatesTags: ['user'],
    }),
    // verify user
    verifyUser: build.mutation({
      query: (data) => ({
        url: '/user/verify-email',
        method: 'POST',
        data: data,
      }),
      invalidatesTags: ['user'],
    }),
    // resend verification code
    resendVerificationCode: build.mutation({
      query: (data) => ({
        url: `/user/resend-verification-email/${data.id}`,
        method: 'POST',
      }),
      invalidatesTags: ['user'],
    }),
    normalUserDetails: build.query({
      query: (id: string) => ({
        url: `/user/${id}`,
        method: 'GET',
        credentials: 'include',
      }),
    }),
    normalUserProfileUpdate: build.mutation({
      query: ({ id, data }: { id: string; data: any }) => ({
        url: `/user/update-user/${id}`,
        method: 'PATCH',
        data,
        credentials: 'include',
      }),
      invalidatesTags: ['auth'],
    }),
    // login mutation
    login: build.mutation({
      query: (data) => ({
        url: '/user-authentication/login',
        method: 'POST',
        data,
        credentials: 'include',
      }),
      invalidatesTags: ['auth'],
    }),
    // logout mutation
    logout: build.mutation({
      query: () => ({
        url: '/user-authentication/logout',
        method: 'POST',
        credentials: 'include',
      }),
      invalidatesTags: ['auth'],
    }),

    // password reset mutation
    resetPassword: build.mutation({
      query: (data) => ({
        url: '/user-authentication/reset-password',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['auth'],
    }),

    // set password mutation
    setPassword: build.mutation({
      query: ({ data, token }) => ({
        url: `/user-authentication/set-password/${token}`,
        method: 'POST',
        data: data,
      }),
      invalidatesTags: ['auth'],
    }),

    // ads api
    getAds: build.query({
      query: (name: string) => ({
        url: `/others/get-ads-code/${name}`,
        method: 'GET',
        credentials: 'include',
      }),
    }),
    // create ads
    createAds: build.mutation({
      query: (data) => ({
        url: '/others/add-ads-code',
        method: 'POST',
        data,
        credentials: 'include',
      }),
      invalidatesTags: ['auth'],
    }),
    // get all ads
    getAllAds: build.query({
      query: () => ({
        url: '/others/get-all-ads-codes',
        method: 'GET',
        credentials: 'include',
      }),
    }),

    // delete ads
    deleteAds: build.mutation({
      query: (id: string) => ({
        url: `/others/delete-ads-code/${id}`,
        method: 'DELETE',
        credentials: 'include',
      }),
      invalidatesTags: ['auth'],
    }),
    // update ads code
    updateAds: build.mutation({
      query: ({ id, data }: { id: string; data: any }) => ({
        url: `/others/update-ads-code/${id}`,
        method: 'PATCH',
        data,
        credentials: 'include',
      }),
      invalidatesTags: ['auth'],
    }),
    // contact us mutation
    contactUs: build.mutation({
      query: (data) => ({
        url: '/others/contact-us',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['auth'],
    }),
    changePassword: build.mutation({
      query: (data) => ({
        url: '/user-authentication/change-password',
        method: 'PATCH',
        data,
        credentials: 'include',
      }),
      invalidatesTags: ['auth'],
    }),
  }),
});

export const {
  useNormalUserDetailsQuery,
  useNormalUserProfileUpdateMutation,
  useGetAdsQuery,
  useCreateAdsMutation,
  useGetAllAdsQuery,
  useDeleteAdsMutation,
  useUpdateAdsMutation,
  useCreateUserMutation,
  useVerifyUserMutation,
  useResendVerificationCodeMutation,
  useLogoutMutation,
  useLoginMutation,
  useResetPasswordMutation,
  useSetPasswordMutation,
  useContactUsMutation,
  useChangePasswordMutation,
} = authApi;
